/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useMemo, useEffect } from "react";
import { NavLink } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandLess from "@mui/icons-material/ExpandLess";
import Collapse from "@mui/material/Collapse";
import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import styles from "./styles";

const getUserRole = () => {
  return localStorage.getItem("role") || "user";
};

const PRIMARY_BLUE = "#183053";

function NavItem({
  icon,
  title,
  members,
  path,
  isParent = false,
  isSubMenu = false,
  ...props
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isExpand, setIsExpand] = useState(false);
  const hasNestedLinks = members?.length;
  const userRole = getUserRole();

  const filteredMembers = useMemo(() => {
    if (!members) return [];
    return members.filter((item) => {
      if (!item.allowedRoles || item.allowedRoles.length === 0) return true;
      return item.allowedRoles.includes(userRole);
    });
  }, [members, userRole]);

  if (isParent && members && filteredMembers.length === 0) {
    return null;
  }

  const onExpandChange = () => {
    setIsExpand((prev) => !prev);
    if (props.onClick) {
      props.onClick();
    }
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath.includes(path)) {
      setIsExpand(true);
    }
  }, [path]);

  const Component = useMemo(() => {
    return hasNestedLinks ? "div" : NavLink;
  }, [hasNestedLinks]);

  const getOuterLinkStyle = () => {
    if (hasNestedLinks) {
      return {
        ...styles.link,
        ...(hasNestedLinks ? styles.nestedLink : {}),
      };
    }
    return ({ isActive }) => ({
      ...styles.link,
      ...(hasNestedLinks ? styles.nestedLink : {}),
      ...(isActive ? styles.activeLink : {}),
    });
  };

  const getOuterLinkStyleMobile = () => {
    if (hasNestedLinks) {
      return {
        ...styles.linkMobile,
        ...(hasNestedLinks ? styles.nestedLink : {}),
      };
    }
    return ({ isActive }) => ({
      ...styles.linkMobile,
      ...(hasNestedLinks ? styles.nestedLink : {}),
      ...(isActive ? styles.activeLink : {}),
    });
  };

  const getClassName = () => {
    if (hasNestedLinks) return "";
    return ({ isActive }) => (isActive ? "active-sidebar-navitem" : "");
  };

  const subMenuStyle = isSubMenu
    ? {
        paddingLeft: "5px",
        gap: 0,
        cursor: "pointer",
        margin: "4px 0",
        borderRadius: "4px",
        fontWeight: "500",
        letterSpacing: "0px",
      }
    : {};

  const parentTab = (
    <Component
      to={path}
      style={isMobile ? getOuterLinkStyleMobile() : getOuterLinkStyle()}
      className={getClassName()}
      onClick={onExpandChange}
    >
      <Box
        style={{
          ...(isMobile ? styles.navContainerMobile : styles.navContainer),
          ...subMenuStyle,
        }}
        sx={styles.hover}
      >
        <div style={styles.icon} className="active-sidebar-icon">
          {icon || (
            <FiberManualRecordIcon
              style={{
                fontSize: 10,
                color: "#fff",
              }}
            />
          )}
        </div>
        <div style={styles.title}>{title}</div>
        <div style={styles.expandArrow}>
          {!props.hideArrow && (
            <>
              {hasNestedLinks && isExpand ? (
                <ExpandLess htmlColor={PRIMARY_BLUE} />
              ) : (
                <ArrowForwardIosIcon sx={{ fontSize: 15 }} />
              )}
            </>
          )}
        </div>
      </Box>
    </Component>
  );

  if (isParent) {
    return (
      <>
        {parentTab}
        {filteredMembers.length > 0 && (
          <Collapse in={isExpand} timeout="auto" style={styles.collapse}>
            {filteredMembers.map((item) => (
              <NavItem key={item.path} {...item} isSubMenu />
            ))}
          </Collapse>
        )}
      </>
    );
  }

  if (!hasNestedLinks) {
    return (
      <NavLink
        to={path}
        style={({ isActive }) => ({
          ...(isMobile ? styles.linkMobile : styles.link),
          ...(isActive ? styles.activeLink : {}),
        })}
        className={({ isActive }) =>
          isActive ? "active-sidebar-nested" : "not-active-sidebar-nested"
        }
      >
        <Box
          style={{
            ...(isMobile ? styles.navContainerMobile : styles.navContainer),
            ...(isMobile
              ? styles.nestedContainerMobile
              : styles.nestedContainer),
            ...subMenuStyle,
          }}
        >
          {icon ? (
            <div style={styles.icon} className="active-sidebar-icon">
              {icon}
            </div>
          ) : (
            <div style={styles.dot} className="sidebar-dot" />
          )}
          <div style={styles.title}>{title}</div>
          <div style={styles.expandArrow} />
        </Box>
      </NavLink>
    );
  }

  return null;
}

export default NavItem;
